import React from 'react';

import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  videoGridContainer: {
    alignItems: 'start',
    display: 'flex',
  },
}));

/* eslint-disable jsx-a11y/media-has-caption */
export default ({ video, onPlayVideo }) => {
  const classes = useStyles();

  const handlePlayVideo = () => {
    if (!onPlayVideo || typeof onPlayVideo !== 'function') return;
    onPlayVideo();
  };

  return (
    <Grid container>
      <Grid item xs={12} className={['mb-1', classes.videoGridContainer].join(' ')}>
        {video?.url ? (
          <div style={{ border: '1px solid #E7E7E7', borderRadius: '5px', display: 'flex', overflow: 'hidden', width: '100%' }}>
            <video controls width="100%" key={video.url} poster={video.thumbnail} preload onPlay={handlePlayVideo}>
              <source src={video.url} />
            </video>
          </div>
        ) : null}
      </Grid>
    </Grid>
  );
};
